document.addEventListener('DOMContentLoaded', function () {
  const tps = timekit_project_selector;

  // Exit early if no appointment category is set
  if (!window.tulipConfig || !window.tulipConfig.appointmentCategory) {
    console.log('Tulip widget not rendered: No appointment category specified');
    return;
  }

  // Construct filters object based on appointment category metafield
  const filters = {
    t_disabled: 0,
    t_private: 0
  };

  // Add category filter only if metafield value exists and is not "show_all"
  if (window.tulipConfig.appointmentCategory && window.tulipConfig.appointmentCategory !== 'show_all') {
    const categoryKey = `t_category_${window.tulipConfig.appointmentCategory}`;
    filters[categoryKey] = 1;
  }

  tps
    .init({
      app_key: window.tulipConfig.appKey,
      api_base_url: window.tulipConfig.apiBaseUrl,
      shouldConsiderAssociateAvailability: true,
      shouldAutomaticallyBookAssociates: true,
      defaultUI: true,
      embed: true,
      includePrivateAppointments: true,
      selectorOptions: {
        service_project: {
          strategy: 'service_project',
          card_title: `{{[project]name}}`,
          title: 'Select an Appointment Type',
          card_image: `{{[project]image_url}}`,
          card_body: `{{[project]description}}`,
          description: 'Which appointment type would you like?',
          card_footer: '<i class="far fa-clock"></i> {{[project]availability.length}}',
          filters: filters,
        },
        store_project: {
          title: 'Select a Store',
          strategy: 'store_project',
          card_title: '[meta]t_store_name',
          card_footer: '[meta]t_store_phone',
          card_body: `{{[meta]t_store_address}}, {{[meta]t_store_city}}`,
          description: 'Choose a store from the following that you will be visiting for your appointment.',
          search_bar: {
            enabled: true,
            placeholder: 'Search for a city or postal code',
          },
        },
      },
    })
    .then(async () => {
      console.log('TimeKit Project Selector initialized');
    })
    .catch((error) => {
      console.log(error.message);
    });
});